module.exports = __webpack_public_path__ + "static/media/google_icon.6cd362d7.svg";